<script>
export default {
  data() {
    return {
      
    }
  }
}
</script>

<template>
  <div :class="$style.sectionTop">
    <div class="container--big section">
      <div class="sectionTop__Inner">
        <div class="sectionTop__left">
          <div class="sectionTop__title">
            <span class="sectionTop__title__subTitle font-cursive ls-0 color-primary">iPet Booking</span>
            <h2 class="sectionTop__title__primaryTitle mb-5">如何做個賺錢的寵物服務</h2>
          </div>
          <p class="sectionTop__content color-text-2">
            迎向數位化經營時代，讓你的寵物服務大升級！真正創造收益，找回開店經營的樂趣！
          </p>
          <BaseButton :to="{ name: 'contact' }" class="isStylePrimary sectionTop__title__contact">
            專人聯繫 <i class="icomoon icon-arrow-button"></i>
          </BaseButton>
        </div>
        <div class="sectionTop__right d-flex">
          <div class="sectionTop__right__dog">
          </div>
          <div class="sectionTop__right__pic">
              <!-- <iframe  src="https://www.youtube.com/embed/Dx5qFachd3A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
              <!-- <img src="@assets/images/adminImgs/home_top.png" alt=""> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionTop {
     position: relative;
     @include max-md {
       padding-top: 94px;
       overflow: hidden;
     }
    &:before {
      content:url('@assets/images/home/section1-bg.svg');
      position: absolute;
      top: -200px;
      right: 0;
      @include max-lg {
        display: none;
      }
    }
    &:after {
      content:'';
      position: absolute;
      bottom: 225px;
      left: 93%;
      background-image: url('@assets/images/home/section1-bg-paw.svg');
      background-repeat: no-repeat;
      background-repeat: no-repeat;
      background-size: contain;
      padding-bottom: 8%;
      width: 100%;
      @include max-xl {
        display: none;
      }
    }
    :global {
      .sectionTop {
        &__Inner {
          padding-top: 40px;
          position: relative;
          right: 10px;
          display: flex;
          flex-wrap: wrap;
          margin-right: -20px;
          margin-left: -20px;
          @media screen and (max-width: 1400px) {
            margin-left: 0px;
          }
        }
        &__title {
          position: relative;
          // max-width: 600px;
          width: 100%;
          @media screen and (max-width: 1400px) {
            margin: 0 auto;
          }
          @include max-sm {
            // max-width: 250px;
          }
          
          &:before {
            content: '';
            position: absolute;
            left: -119px;
            top: -60px;
            background-image: url('~@assets/images/home/section1-paw.svg');
            background-repeat: no-repeat;
            background-size: contain;
            width: 236px;
            padding-bottom: 53%;
            @include max-md {
              width: 173px;
              padding-bottom: 33%;
              left: -10px;
              top: -43px
            }
            @include max-sm {
              padding-bottom: 81%;
              left: -55px
            }
          }
          &__subTitle {
            font-size: 28px;
            @include max-md {
              font-size: 21px;
            }
          }
          &__primaryTitle {
            font-size: 50px;
            font-weight: 600;
            @include max-md {
              font-size: 42px;
            }
          }
        }
        &__content {
          margin-bottom: 6rem;
          font-size: 18px;
          @include max-md {
            font-size: 16px;
            margin-bottom: 2.5rem
          }
          @include max-sm {
            font-size: 14px;
          }
        }
        &__left {
          flex: 0 0 47.6666666667%;
          max-width: 47.6666666667%;
          width: 100%;
          padding-right: 20px;
          padding-left: 10%;
          @include max-2xl {
            padding-left: 15%;
          }
          @media screen and (max-width: 1800px) {
            padding-left: 5%;
          }
          @media screen and (max-width: 1400px) {
            flex: 0 0 100%;
            max-width: 100%;
            padding-left: 20px;
            text-align: center;
            padding-left: 5%;
          }
         
        }
        &__right {
          flex: 0 0 52.3333333333%;
          max-width: 52.3333333333%;
          width: 100%;
          padding-right: 20px;
          padding-left: 20px;
          position: relative;
          @media screen and (max-width: 1400px) {
            flex: 0 0 100%;
            max-width: 100%;
            margin-top: 90px;
            &:before {
              content: '';
              position: absolute;
              background-image: url('~@assets/images/home/section1-bg-no-crop.svg');
              background-repeat: no-repeat;
              background-size: contain;
              padding-bottom: 100%;
              width: 50%;
              bottom: -50%;
              right: -20px;
              display: none;
              @include max-lg {
                display: block;
              }
            }
          }
         &__dog {
          position: absolute;
          background-image: url('~@assets/images/home/section1-dog-shadow.png');
          background-repeat: no-repeat;
          background-size: cover;
          width: 37%;
          padding-top: 40%;
          z-index: 7;
          bottom: 17%;
          left: 1%;
          @media screen and (max-width: 1600px) {
            bottom: 5%;
          }
          @media
            only screen and (-webkit-min-device-pixel-ratio: 2),
            only screen and (   min--moz-device-pixel-ratio: 2),
            only screen and (     -o-min-device-pixel-ratio: 2/1),
            only screen and (        min-device-pixel-ratio: 2),
            only screen and (                min-resolution: 192dpi),
            only screen and (                min-resolution: 2dppx) { 
              background-image: url('~@assets/images/home/section1-dog-shadow@2x.png');
            }
         }
         &__pic {
          
          position: relative;
          background-image: url('~@assets/images/home/section1-laptop.png');
          padding-bottom: 63%;
          width: 100%;
          background-repeat: no-repeat;
          background-size: contain;
          top: -12%;
          right: -14%;
          bottom: 0;
          z-index: 5;
          @media screen and (max-width: 1600px) {
            top: 0;
          }
          iframe, img {
            position: absolute;
            z-index: 6;
            top: 4%;
            right: 0;
            left: 10%;
            bottom: 0;
            width: 62.5%;
            height: 64%;
          }
         }
        }
      }
    }
  }
</style>